var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('b-icon',{attrs:{"icon":"arrow-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }